import { Table } from '@ui/src';
import { ContractTypes } from './types';
import {
  columns,
  columnsLabels,
} from '../../../hoc/common/beneficiaries/variables/transactions';
import BeneficiaryContractDetails from './parts/contract-details';

import cn from './styles.module.css';

const BeneficiaryContract = ({
  panelState,
  setPanelState,
  onRowClick,
  formattedData,
  control,
  errors,
  beneficiaryContract,
  baseCurrency,
  getFile,
  downloadId,
  downloadError,
  downloadInProgress,
  currencies,
  selectedCurrency,
  setSelectedCurrency,
  currenciesList,
  organizationStatus,
  uploadedDocuments,
  beneficiary,
  downloadIsFetching,
}: ContractTypes) => (
  <>
    <div className={cn.contractTabsWrapper}>
      <button
        type="button"
        className={`${cn.contractTabButton} ${
          panelState === 'details' ? cn.active : ''
        }`}
        onClick={() => setPanelState('details')}
      >
        Details
      </button>
      <button
        type="button"
        className={`${cn.contractTabButton} ${
          panelState === 'transactions' ? cn.active : ''
        }`}
        onClick={() => setPanelState('transactions')}
      >
        Transactions
      </button>
    </div>
    {panelState === 'transactions' && (
      <Table
        columns={columns}
        tableFormClassName={cn.transactionTable}
        data={formattedData || []}
        onSort={() => {}}
        filters={{}}
        sort={{}}
        columnsLabels={columnsLabels}
        onFilterChange={() => {}}
        onRowClick={(id) => onRowClick(id)}
      />
    )}
    {panelState === 'details' && (
      <BeneficiaryContractDetails
        control={control}
        beneficiaryContract={beneficiaryContract}
        errors={errors}
        baseCurrency={baseCurrency}
        beneficiaryName={beneficiary?.name}
        documents={uploadedDocuments}
        getFile={getFile}
        downloadId={downloadId}
        downloadError={downloadError}
        downloadInProgress={downloadInProgress || downloadIsFetching}
        currencies={currencies}
        selectedCurrency={selectedCurrency}
        setSelectedCurrency={setSelectedCurrency}
        currenciesList={currenciesList}
        organizationStatus={organizationStatus}
      />
    )}
  </>
);

export default BeneficiaryContract;
